import { isNil, isEmpty, size, isFunction, sortBy } from 'lodash';
import ServiceUrls from '@/lib/ServiceUrls';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { TimelineMax, TweenMax } from 'gsap';
import FilterMixin from './FilterMixin';

// define a mixin object
export default {

  data() {
    return {
      templates: null,
      templateDocuments: {
        GuestOfferDocument: {
          canHaveMultiple: true,
          systemTemplate: false,
        },
        GuestOfferEmail: {
          canHaveMultiple: false,
          systemTemplate: false,
        },
        PaymentConfirmationEmail: {
          canHaveMultiple: false,
          systemTemplate: false,
        },
        ReservationConfirmationEmail: {
          canHaveMultiple: true,
          systemTemplate: false,
        },
        GenericEmail: {
          canHaveMultiple: true,
          systemTemplate: false,
        },
        GenericDocument: {
          canHaveMultiple: true,
          systemTemplate: false,
        },
      },
    };
  },

  watch: {
    enums: function () {
      if (!isNil(this.$store.getters['enums/enums']) && !isNil(this.$store.getters['enums/enums'].TemplateDocument)) {
        this.$store.getters['enums/enums'].TemplateDocument
          .filter(it => isNil(this.templateDocuments[it]))
          .forEach((it) => {
            this.templateDocuments[it] = {
              systemTemplate: true,
            };
          });
      }
    },
  },

  mounted: function () {
    if (!isNil(this.$store.getters['enums/enums'])) {
      this.$store.getters['enums/enums'].TemplateDocument
        .filter(it => isNil(this.templateDocuments[it]))
        .forEach((it) => {
          this.templateDocuments[it] = {
            systemTemplate: true,
          };
        });
    }

    this.loadTemplateList();
  },

  methods: {
    loadTemplateList() {
      this.axios.get(this.serviceUrls.template.list(this))
        .then((response) => {
          this.templates = sortBy(response.data.data, ['documentType', 'name']);

          this.$serviceBus.$emit('template.list', this.templates);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/TemplateMixin.js